import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass([
          'tw-flex tw-flex-row tw-grow tw-items-center tw-gap-2',
          'tw-border-0',
          'tw-py-0.5 tw-px-1'
        ])
}

import CheckboxIcon from 'frontcore/views/selection-control/checkbox-icon/CheckboxIcon.vue'
import ImageIcon from 'frontcore/views/icons/image-icon/ImageIcon.vue'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { CheckboxState } from 'frontcore/views/selection-control/types'
import { computed } from 'vue'

interface Props {
  id: number | string
  text: string
  dataTest?: string
  disabled?: boolean
  iconColorClass?: string
  iconName?: string
  imageSrc?: string
  selected?: boolean
  multiple?: boolean
}

type Emits = (e: 'onClickOption', value: Props['id']) => void


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownMenuItem',
  props: {
    id: {},
    text: {},
    dataTest: {},
    disabled: { type: Boolean, default: false },
    iconColorClass: {},
    iconName: {},
    imageSrc: {},
    selected: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false }
  },
  emits: ["onClickOption"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const iconColorClass = computed(() => {
  if (props.disabled) return 'tw-fill-core-neutral-cold-70'
  if (props.iconColorClass) return props.iconColorClass
  if (props.selected) return 'tw-fill-core-primary-30'
  return 'tw-fill-core-primary-50'
})

const onHandlerOption = ():void => {
  if (props.disabled) return
  emit('onClickOption', props.id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "drop-down-menu-item__wrapper tw-p-1",
    tabindex: "0",
    "data-test": _ctx.dataTest,
    onClick: _withModifiers(onHandlerOption, ["stop","prevent"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'tw-flex tw-flex-row tw-justify-between tw-items-center',
        'tw-p-1 tw-gap-2',
        'tw-rounded tw-border-0',
        'tw-cursor-pointer',
        'hover:tw-bg-core-primary-95',
        'drop-down-menu-item',
        { 'tw-bg-core-primary-80': _ctx.selected },
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.multiple)
          ? (_openBlock(), _createBlock(CheckboxIcon, {
              key: 0,
              value: _ctx.selected ? _unref(CheckboxState).CHECKED : _unref(CheckboxState).UNCHECKED,
              disabled: _ctx.disabled
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.iconName)
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 1,
              "data-test": "drop-down-menu-item-icon",
              colorClass: iconColorClass.value,
              iconName: _ctx.iconName,
              remSize: 1.25
            }, null, 8, ["colorClass", "iconName"]))
          : (_ctx.imageSrc)
            ? (_openBlock(), _createBlock(ImageIcon, {
                key: 2,
                imageSrc: _ctx.imageSrc,
                "data-test": "drop-down-menu-item-image-icon"
              }, null, 8, ["imageSrc"]))
            : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass([_ctx.disabled ? 'tw-text-core-neutral-cold-40' : 'tw-text-core-primary-10', "drop-down-menu-item__title body--body-01"]),
          "data-test": "drop-down-menu-item-label"
        }, _toDisplayString(_ctx.text), 3)
      ]),
      (!_ctx.multiple && _ctx.selected)
        ? (_openBlock(), _createBlock(SVGIcon, {
            key: 0,
            iconName: "CheckCircle",
            colorClass: _ctx.disabled ? 'tw-fill-core-neutral-cold-50' : 'tw-fill-core-primary-30',
            remSize: 1.25
          }, null, 8, ["colorClass"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1))
}
}

})